

    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from "../lib/Question";
    import {api} from "../Api";
    import {AxiosResponse} from "axios";

    @Component({})
    export default class GuaranteeFullQuestion extends Vue {
        @Prop()
        public question: Question;
        public guarantees = [];
        public categories = [];
        public objects: any = [];
        public currentCustomIndex = null;
        public answer: any = {};


        loadGuarantees() {
            const currentBranch = this.question.section.step.branch.id;
            const guarantees = this.$store.state.guarantees;
            guarantees.forEach((guarantee) => {
                // console.log(guarantee);
                if (guarantee.branch.id === currentBranch) {
                    this.guarantees.push({
                        id: guarantee.id,
                        name: guarantee.label,
                        selected: false,
                        capital: 0,
                    });
                }
            });
        }

        loadCategories() {
            const currentBranch = this.question.section.step.branch.id;
            const cats = this.$store.state.packCategories;
            cats.forEach((cat) => {
                if (cat.branchId === currentBranch) {
                    this.categories.push({
                        id: cat.id,
                        label: cat.label,
                    });
                }
            });
        }

        closeCurrentCustomIndex() {
            this.currentCustomIndex = null;
        }

        //  SHOULD BE UPDATE
        loadObjects() {
            api.getObjectsFromResponseGroup(this.question.currentResponse.responseGroup).then((response: AxiosResponse) => {
                if(response.data.status === 'success'){
                    Object.keys(response.data.data).forEach((key) => {
                        const object = {index: key, packCategory: null, item: response.data.data[key]};
                        object.item.category = 0;
                        object.item.customGuarantees = [];
                        this.objects.push(object);
                    });
                }


            });
            /*this.objects = {
                22000: {
                    vehicleIdentificationNumber: '3040GA01',
                    brand: {
                        id: 1,
                        label: 'peugeot',
                    },
                    make: {
                        id: 1,
                        label: '406',
                    },
                    dateVehicleFirstRegistered: new Date(),
                    newValue: 10000000,
                    marketValue: 8000000,
                    // packCategory: null,
                    customGuarantees: [],
                },
                22001: {
                    vehicleIdentificationNumber: '3041GA01',
                    brand: {
                        id: 1,
                        label: 'peugeot',
                    },
                    make: {
                        id: 1,
                        label: '407',
                    },
                    dateVehicleFirstRegistered: new Date(),
                    newValue: 20000000,
                    marketValue: 18000000,
                    // packCategory: null,
                    customGuarantees: [],
                }
            };*/
        }

        public displayDate(date: any) {
            return moment(date).format('DD/MM/YYYY');
        }

        public getItem(index) {
            const item = this.objects.find((item) => item.index == index);
            return item.item;
        }

        customizeGuarantees(index) {
            this.currentCustomIndex = index;

        }

        isCustomGuaranteeSelected(index, guarantee) {
            const object = this.getItem(index);
            return object.customGuarantees.indexOf(guarantee) !== -1;
        }

        saveCustomGuarantees() {
            const object = this.getItem(this.currentCustomIndex);

            if (object.customGuarantees.length === 0) {
                object.packCategory = null;
            }
            this.currentCustomIndex = null;
        }

        toggleGuarantee(guarantee, index) {
            const object = this.getItem(index);

            if (object.customGuarantees.includes(guarantee)) {
                object.customGuarantees.splice(this.objects[index].customGuarantees.indexOf(guarantee));
            } else {
                object.customGuarantees.push(guarantee);
            }
            // console.log(this.objects[index].customGuarantees);

        }

        save() {

            const answers = [];
            this.objects.forEach((object: any) => {
                const answer: any = {
                    index: object.index,
                    category: object.category,
                    guarantees: object.item.customGuarantees,
                };
                answers.push(answer);
            });
            this.question.currentResponse.value = JSON.stringify(answers);
             this.question.changedEvent.emit("");
             this.question.validate();
        }

        formatCurrency(numberString: string|number) {
            numberString = numberString + '';
            const match = numberString.match(/(\d+?)(?=(\d{3})+(?!\d)|$)/g);
            if(match){
                numberString = match.join(' ');
            }
            return numberString;
        }

        mounted() {
            this.loadGuarantees();
            this.loadCategories();
            this.loadObjects();
            if (this.question.currentResponse.value.length) {
                console.log(this.question.currentResponse.value);
                // let value = JSON.parse(this.question.currentResponse.value);
                // this.objects = value;
            }

        }
    }

